import { useEffect } from "react";

const API_BASE = (process.env.REACT_APP_API_URL || "/api/v1").replace(/\/$/, "");

function decodeVapidKey(value) {
  const padding = "=".repeat((4 - (value.length % 4)) % 4);
  const raw = window.atob((value + padding).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((character) => character.charCodeAt(0)));
}

function sameApplicationServerKey(subscription, expectedKey) {
  const current = subscription?.options?.applicationServerKey;
  if (!current) return false;
  const actual = new Uint8Array(current);
  if (actual.length !== expectedKey.length) return false;
  return actual.every((byte, index) => byte === expectedKey[index]);
}

async function ensurePushSubscription() {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  if (!token || !role || !("serviceWorker" in navigator) || !("PushManager" in window)) return;
  if (!("Notification" in window) || Notification.permission !== "granted") return;

  const configResponse = await fetch(`${API_BASE}/push/config`, { cache: "no-store" });
  if (!configResponse.ok) return;
  const config = await configResponse.json();
  if (!config.enabled || !config.public_key) return;

  const registration = await navigator.serviceWorker.ready;
  const applicationServerKey = decodeVapidKey(config.public_key);
  let subscription = await registration.pushManager.getSubscription();
  if (subscription && !sameApplicationServerKey(subscription, applicationServerKey)) {
    await subscription.unsubscribe();
    subscription = null;
  }
  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey,
    });
  }
  await fetch(`${API_BASE}/push/subscribe`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify(subscription.toJSON()),
  });
}

export default function PushRegistration() {
  useEffect(() => {
    const subscribe = () => ensurePushSubscription().catch((error) => console.warn("Push subscription failed:", error));
    subscribe();
    window.addEventListener("push:subscribe", subscribe);
    const timer = window.setInterval(subscribe, 5 * 60 * 1000);
    return () => {
      window.removeEventListener("push:subscribe", subscribe);
      window.clearInterval(timer);
    };
  }, []);
  return null;
}
